import InfoView from "./InfoView.vue";

const app = new Vue({
    el: '#info-view',
    components: {InfoView}
});
